import React from 'react';
import './components/Dashboard.css';
import SociosList from './components/SociosList';
import NoticiasList from './components/NoticiasList';
import CursosList from './components/CursosList';
import EventosList from './components/EventosList';
import AuthUsersList from './components/AuthUsersList';
import MisProyectosConDocs from './components/MisProyectosConDocs';
import Contacto from './components/Contacto';
import MiCuenta from './components/MiCuenta';
import SociosCredencialesList from './components/SociosCredencialesList';
import ContactosInbox from './components/ContactosInbox';
import CrearProyecto from './components/CrearProyecto';
import ProyectosPendientes from './components/ProyectosPendientes';
import SiteConfigPanel from './components/SiteConfigPanel';
import RegistroSocios from '../RegistroSocios';

function MainDashboard({ token, user, activeTab, onTabChange, permissions, isRegistroSociosRoute }) {
    const { isAdmin, isRevisor, canEditAsistente, allowNoticiasCursosOnly, canSocios, canMisProyectos, canCrearProyectos, canGestionarProyectos, isAsistente } = permissions;

    return (
        <div className="dashboard">
            <div className="dashboard-welcome">
                <p>
                    Bienvenido, <strong>{user?.username || user?.email || 'Usuario'}</strong>
                </p>
            </div>

            <div className="section">
                {activeTab === 'micuenta' && <MiCuenta token={token} />}
                {!allowNoticiasCursosOnly && activeTab === 'gestionar-proyectos' && canGestionarProyectos && (
                    <ProyectosPendientes token={token} isAdmin={isAdmin} isRevisor={isRevisor}/>
                )}
                {!allowNoticiasCursosOnly && activeTab === 'misproyectos' && canMisProyectos && <MisProyectosConDocs token={token} />}
                {!allowNoticiasCursosOnly && activeTab === 'crear-proyecto' && canCrearProyectos && (
                    <CrearProyecto
                        token={token}
                        onFinalizar={() => onTabChange && onTabChange('misproyectos')}
                    />
                )}
                {!allowNoticiasCursosOnly && activeTab === 'socios' && canSocios && (
                    isRegistroSociosRoute
                        ? <RegistroSocios />
                        : <SociosList token={token} isAdmin={isAdmin} user={user} canAccess={canSocios} />
                )}
                {activeTab === 'noticias' && <NoticiasList token={token} canEdit={isAdmin || canEditAsistente} />}
                {activeTab === 'cursos' && <CursosList token={token} canEdit={isAdmin || canEditAsistente} />}
                {activeTab === 'eventos' && <EventosList token={token} canEdit={isAdmin || canEditAsistente} />}
                {activeTab === 'contacto' && <Contacto />}
                {activeTab === 'contactos-inbox' && (isAdmin || isAsistente) && (
                    <ContactosInbox token={token} canAccess={isAdmin || isAsistente} />
                )}
                {activeTab === 'credenciales' && (isAdmin || isAsistente) && <SociosCredencialesList token={token} />}
                {!allowNoticiasCursosOnly && activeTab === 'usuarios' && isAdmin && <AuthUsersList token={token} isAdmin={isAdmin} />}
                {activeTab === 'configuracion' && isAdmin && user?.is_staff && <SiteConfigPanel token={token} />}
            </div>
        </div>
    );
}

export default MainDashboard;
